// extracted by mini-css-extract-plugin
export default {"root":"aStTc64w","saveButton":"ABPkaUg_"};